module.exports = __webpack_public_path__ + "static/media/card.222c9cf6.svg";